import classNames from 'classnames';
import { PropsWithChildren } from 'react';

import style from './section.module.css';

export type SectionBackgroundColor = 'black' | 'white';

interface SectionProps {
  backgroundColor: SectionBackgroundColor;
  id: null | string | undefined;
  innerContainerClassName?: string;
}

const sectionBackgroundColorMap: Record<SectionBackgroundColor, string> = {
  black: style.sectionBlack,
  white: style.sectionWhite,
};

const Section = ({
  backgroundColor,
  children,
  id,
  innerContainerClassName,
}: PropsWithChildren<SectionProps>) => {
  return (
    <section
      className={classNames(
        style.section,
        sectionBackgroundColorMap[backgroundColor],
      )}
      id={id ?? undefined}
    >
      <div
        className={classNames(
          style.sectionContent,
          innerContainerClassName,
        )}
      >
        {children}
      </div>
    </section>
  );
};

export default Section;
